import moment from 'moment';

let defaultDates = [];
let defaultValues = [];
const defaultMap = {};

const startYear = moment().year();
const startDate = moment().startOf('year');
const today = moment().format('MMM D');
let todayIndex = 0;
let newDate = moment().startOf('year');
let days = 0;

while (newDate.year() === startYear && days <= 366) {
  newDate = days === 0 ? moment(startDate) : moment(startDate).add(days, 'days');

  const formatedDate = moment(newDate).format('MMM D');
  defaultDates.push(formatedDate);
  defaultValues.push(0);
  defaultMap[formatedDate] = days;
  if (today === formatedDate) {
    todayIndex = days + 1;
  }
  days += 1;
}

defaultDates = defaultDates.slice(0, todayIndex);
defaultValues = defaultValues.slice(0, todayIndex);

export { defaultDates, defaultValues, defaultMap };
